module.exports = __webpack_public_path__ + "static/media/img_aircash.32014c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_aircash.png
// module id = 515
// module chunks = 0